import { FC } from "react";

export const TabHighlight: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="55"
      height="1"
      viewBox="0 0 55 1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || ""}`}
    >
      <mask id="path-1-inside-1_3_7" fill="white">
        <path d="M0 1H55V0H0V1Z" />
      </mask>
      <path
        d="M55 1H0V-1H55V1Z"
        fill="url(#paint0_linear_3_7)"
        mask="url(#path-1-inside-1_3_7)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3_7"
          x1="55"
          y1="0.5"
          x2="0"
          y2="0.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6EB3FA" stopOpacity="0" />
          <stop offset="1" stopColor="#6EB3FA" />
        </linearGradient>
      </defs>
    </svg>
  );
};
